import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-header-implement',
  templateUrl: './header-implement.component.html',
  styleUrls: ['./header-implement.component.scss']
})
export class HeaderImplementComponent implements OnInit {

  // Objeto representativo del menú
  @Input() menuoptions: string;
  @Input() ishome: string;
  @Input() isbeta: string;
  private translate = new EventEmitter<string>();

  dummyDefaultLanguage: string;

  // Función que emite el resultado emitido por los webcomponents
  private translateEmit(ev){
    this.translate.emit(ev);
    window["translate"].setLanguage(ev.detail.split("-")[0]);
  }

  componentDidLoad() {
    window["translate"].addLanguageChangeListener("language-value-changed");
  }


  constructor() { }

  ngOnInit() {
  }

}
